var prayer = $('.prayer');
var enrollment = $('.enrollment');
var customAmount = $('span.ginput_product_price + input:hidden');
var customAmountLabel = $('span.ginput_product_price');

$(prayer).hide();
$(enrollment).hide();

$('input:radio[name="input_9"]').click( function(){
	var donationAmount = $(this).val();

	if (donationAmount == '$0') {
		$(prayer).hide();
		$(enrollment).hide();

	} else if (donationAmount == '$5') {
		$(prayer).show();
		$(enrollment).hide();
		$( customAmountLabel ).text( donationAmount );
		$( customAmount ).val( donationAmount );

	} else if (donationAmount == '$10') {

		$(prayer).hide();
		$(enrollment).show();
		$( customAmountLabel ).text( donationAmount );
		$( customAmount ).val( donationAmount );

	} else if (donationAmount == 'Other') {
		prayer.hide();
		enrollment.hide();

		$('#input_5_36').on('keyup', function() {
			this.value = this.value.replace(/[^0-9.]/g,'');
			var otherAmount = $(this).val();
			var value = parseFloat(otherAmount);

			if(otherAmount <= 4) {
				$(prayer).hide();
				$(enrollment).hide();
			} else if(otherAmount >= 10) {
				$(prayer).hide();
				$(enrollment).show();

			} else if(otherAmount >= 5) {
				$(prayer).show();
				$(enrollment).hide();

			} else {
				$(prayer).hide();
				$(enrollment).hide();
			}

			$( customAmountLabel ).text( '$' + value );
			$( customAmount ).val( value );

		});

	} else {
		alert('You must enter an amount.');
	}
});



// WEBPACK FOOTER //
// ./theme_components/js/prayer-cards.js